import linkedSubjects from "../models/linked-subjects";

export const types = {
  LINKED_SUBJECTS_REQUEST: "LINKED_SUBJECTS_REQUESTED",
  LINKED_SUBJECTS_DATA: "LINKED_SUBJECTS_DATA",
  LINKED_SUBJECTS_SUCCESS: "LINKED_SUBJECTS_SUCCESS",
  LINKED_SUBJECTS_CLEAR: "LINKED_SUBJECTS_CLEAR",
  LINKED_SUBJECTS_FAILED: "LINKED_SUBJECTS_FAILED",
  LINKED_SUBJECTS_SUBMIT_REQUEST: "LINKED_SUBJECTS_SUBMITTED",
  LINKED_SUBJECTS_SUBMIT_SUCCESS: "LINKED_SUBJECTS_SUBMIT_SUCCESS",
  LINKED_SUBJECTS_SUBMIT_FAILED: "LINKED_SUBJECTS_SUBMIT_FAILED",
  LINKED_SUBJECTS_FORM_RESET: "LINKED_SUBJECTS_FORM_RESET",
  LINKED_SUBJECT_REMOVE: "LINKED_SUBJECT_REMOVE",
  LINKED_SUBJECT_REMOVE_SUCCESS: "LINKED_SUBJECT_REMOVE_SUCCESS",
  LINKED_SUBJECT_REMOVE_FAILED: "LINKED_SUBJECT_REMOVE_FAILED",
};

export const actions = {
  linkedSubjectsClear: () => {
    return { type: types.LINKED_SUBJECTS_CLEAR };
  },
  linkedSubjectsGet: (payload, namespace) => {
    return { type: types.LINKED_SUBJECTS_REQUEST, value: payload, namespace };
  },
  linkedSubjectsDataGet: (payload) => {
    return { type: types.LINKED_SUBJECTS_DATA, value: payload };
  },
  linkedSubjectsSubmit: (payload, callback = () => { }) => {
    return { type: types.LINKED_SUBJECTS_SUBMIT_REQUEST, value: payload, callback };
  },
  linkedSubjectsFormReset: (payload) => {
    return { type: types.LINKED_SUBJECTS_FORM_RESET, value: payload };
  },
  linkedSubjectsRemove: (payload, callback = () => { }) => {
    return { type: types.LINKED_SUBJECT_REMOVE, value: payload, callback };
  },
};

function setViewConfig(value) {
  if (typeof value?.name === 'string') {
    return {
      title: {
        en: value?.name,
        fr: value?.name
      },
    };
  }

  const { data } = value[Object.keys(value)[0]];

  if (!data) {
    return {};
  }

  return {
    title: {
      en: data.name || data.title,
      fr: data.name || data.title
    },
  };
}

const reducer = (state = linkedSubjects, action) => {
  const { data = {} } = state;
  switch (action.type) {
    case types.LINKED_SUBJECTS_CLEAR:
      return {
        ...state,
        loading: true,
        retrived: false,
        data: {
          data: [],
          options: {},
          totalItems: 0,
        },
      };
    case types.LINKED_SUBJECTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.LINKED_SUBJECTS_DATA:
      return {
        ...state,
      };
    case types.LINKED_SUBJECTS_SUCCESS:
      return {
        ...state,
        loading: false,
        retrived: true,
        data: {
          ...data,
          ...action.value,
        },
        viewConfig: {
          ...setViewConfig(action.value),
        },
      }
    case types.LINKED_SUBJECTS_SUBMIT_SUCCESS:
      if (!data[`${action.value.module}-${action.value.view}`]) {
        data[`${action.value.module}-${action.value.view}`] = {}
      }
      data[`${action.value.module}-${action.value.view}`].data = action.value;
      return {
        ...state,
        loading: false,
        retrived: true,
        data: {
          ...data,
        },
        viewConfig: {
          ...setViewConfig(data),
        },
      };
    case types.LINKED_SUBJECTS_FORM_RESET:
      delete state.data[`${action.value.module}-${action.value.view}`];
      return {
        ...state,
        loading: false,
      };
    case types.LINKED_SUBJECTS_SUBMIT_FAILED:
      return {
        ...state,
        loading: false,
        errors: action.value || null,
      };
    default:
      return state;
  }
};

export default reducer;
